"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraSelectorSwitch = void 0;
var _ = require("../..");
var _FormDropdown = require("../../FormDropdown");
var _constants = require("@studio/constants");
var _JoinComponent = require("../JoinComponent.styled");
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../hooks");
var _constants2 = require("../../../constants");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _feature = require("@studio/feature.flags");
/**
 * Component that provides camera selection and background blur toggle functionality.
 * Initializes background filter and displays error if initialization fails.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.selectedVideoInput - Currently selected video input device ID
 * @param {Array<Object>} props.videoInputDevices - List of available video input devices
 * @param {Function} props.onCameraChange - Callback for when camera selection changes
 * @param {boolean} props.disabled - Whether the controls should be disabled
 * @param {string} props.userBackground - Current background setting (NONE or BLUR)
 * @param {Function} props.setUserBackground - Function to update background setting
 * @param {Function} props.initializeBackgroundFilter - Function to initialize background filter
 * @returns {React.Element} Rendered component
 */
var CameraSelectorSwitch = exports.CameraSelectorSwitch = function CameraSelectorSwitch(_ref) {
  var _selectedVideoInput$d;
  var selectedVideoInput = _ref.selectedVideoInput,
    videoInputDevices = _ref.videoInputDevices,
    onCameraChange = _ref.onCameraChange,
    disabled = _ref.disabled,
    userBackground = _ref.userBackground,
    setUserBackground = _ref.setUserBackground,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter;
  var isBlurredBackgroundEnabled = (0, _feature.shouldHaveFeature)('studio-agora-blurred-backgrounds');
  var backgroundFilterStatus = (0, _hooks.useInitializeBackgroundFilter)({
    initializeBackgroundFilter: initializeBackgroundFilter
  });
  var isBackgroundFilterInitialized = backgroundFilterStatus === _constants2.INITIALIZATION_STATE.SUCCESS;
  var isBackgroundFilterInitializationFailed = backgroundFilterStatus === _constants2.INITIALIZATION_STATE.FAILED;
  var onCameraChangeWithBackground = function onCameraChangeWithBackground(event) {
    setUserBackground(userBackground === _constants.BACKGROUND_OPTIONS.BLUR ? _constants.BACKGROUND_OPTIONS.NONE : _constants.BACKGROUND_OPTIONS.BLUR);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormDropdown.FormDropdown, {
    labelText: "Select Camera",
    "data-testid": "selectCamera",
    selected: (_selectedVideoInput$d = selectedVideoInput === null || selectedVideoInput === void 0 ? void 0 : selectedVideoInput.device) !== null && _selectedVideoInput$d !== void 0 ? _selectedVideoInput$d : selectedVideoInput,
    options: videoInputDevices,
    id: "selectCamera",
    onChange: onCameraChange,
    disabled: disabled,
    className: "mb-0"
  }), isBackgroundFilterInitialized && isBlurredBackgroundEnabled && /*#__PURE__*/_react["default"].createElement(_.Switch, {
    className: "pt-1",
    labelText: "Blur background",
    id: "blurBackground",
    "data-testid": "blurBackground",
    disabled: disabled,
    checked: userBackground === _constants.BACKGROUND_OPTIONS.BLUR,
    "data-dd-action-name": "Background option switched to ".concat(userBackground === _constants.BACKGROUND_OPTIONS.BLUR ? _constants.BACKGROUND_OPTIONS.NONE : _constants.BACKGROUND_OPTIONS.BLUR),
    onChange: onCameraChangeWithBackground
  }), isBackgroundFilterInitializationFailed && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledVirtualBackgroundErrorText, {
    type: "error",
    text: _constants.DEVICE_NOT_SUPPORTED_MESSAGE,
    id: "virtual-background-disabled",
    "data-testid": "virtual-background-disabled"
  }));
};
CameraSelectorSwitch.propTypes = {
  selectedVideoInput: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  videoInputDevices: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  onCameraChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  userBackground: _propTypes["default"].string.isRequired,
  setUserBackground: _propTypes["default"].func.isRequired,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired
};